export const EXTRA_LESSONS = '/api/v1/lessons/courses';

export const EXTRA_LESSONS_SETTLEMENT = '/api/v1/settlements/courses';
export const EXTRA_LESSON = (courseId: string) => `/api/v1/settlements/courses/${courseId}`;

export const EXTRA_LESSON_JOURNALS = (courseId: string) =>
    `/api/v1/settlements/courses/${courseId}/journals`;

export const STAFF = '/api/v1/settlements/staff';

export const COST_ALLOCATIONS = '/api/v2/child-settlements/cost-split';
export const COST_SPLIT = (costAllocationId: string) =>
    `/api/v2/child-settlements/cost-split/${costAllocationId}`;

export const SETTLEMENTS_SUMMARY_V2 = '/api/v2/child-settlement/list';

export const CHILD_SETTLEMENT = '/api/v2/settlement/summary/monthly-settlement';
export const IS_CHILD_SETTLEMENT_ACTIVE = '/api/v2/child-settlement/active';

export const ADD_CHILD_SETTLEMENT_TRANSACTION_COST = '/api/v1/transactions/cost';
export const ADD_CHILD_SETTLEMENT_TRANSACTION_PAYMENT = '/api/v1/transactions/payment';
export const EDIT_CHILD_SETTLEMENT_TRANSACTION = (transactionId: string) =>
    `/api/v1/transactions/${transactionId}/adjust`;
export const REMOVE_CHILD_SETTLEMENT_TRANSACTION = (transactionId: string) =>
    `/api/v1/transactions/${transactionId}/reverse`;

export const CHILD_SETTLEMENT_TRANSACTION = (transactionId: string) =>
    `/api/v1/transactions/${transactionId}`;

export const VERIFY_CHILD_SETTLEMENT_V2 = (settlementId: string) =>
    `/api/v2/child-settlement/verify/${settlementId}`;
export const TOGGLE_CHILD_SETTLEMENT_PAID = (settlementId: string) =>
    `/api/v2/child-settlement/paid/${settlementId}`;
export const VERIFY_MONTHLY_SETTLEMENT_CORRECTION = (correctionId: string) =>
    `/api/v2/child-settlements/correction/verify/${correctionId}`;

export const RECALCULATE_CHILD_SETTLEMENT = '/api/v2/child-settlement/child';

export const CHILD_SETTLEMENT_BALANCE = '/api/v1/balance';

export const GET_MANUAL_BILL = (manualBillId: string) =>
    `/api/v2/child-settlements/additional-cost/${manualBillId}`;
export const ADD_ADDITIONAL_COST = '/api/v2/child-settlements/additional-cost';
export const EDIT_ADDITIONAL_COST = (manualBillId: string) =>
    `/api/v2/child-settlements/additional-cost/${manualBillId}`;
export const EDIT_ADDITIONAL_COST_CORRECTION = (correctionId: string) =>
    `/api/v2/child-settlements/correction/additional-cost/${correctionId}`;
export const DELETE_ADDITIONAL_COST = (additionalCostId: string) =>
    `/api/v2/child-settlements/additional-cost/${additionalCostId}`;
export const TOGGLE_ADDITIONAL_COST_PAID = (additionalCostId: string) =>
    `/api/v2/child-settlements/additional-cost/paid/${additionalCostId}`;
export const VERIFY_ADDITIONAL_COST = (additionalCostId: string) =>
    `/api/v2/child-settlements/additional-cost/${additionalCostId}/verify`;
export const ADD_ADDITIONAL_COST_CORRECTION = `/api/v2/child-settlements/correction/additionalCost`;

export const ADDITIONAL_COSTS_SETTLEMENT = '/api/v2/settlement/summary/additional-costs';
export const ADD_OR_VERIFY_MONTHLY_SETTLEMENT_CORRECTION =
    '/api/v2/child-settlements/correction/monthlySettlement';

export const CHILD_INCOMES = '/api/v1/transactions/manual';
